export default "__VITE_PUBLIC_ASSET__e8cd0a48__"